module.exports = __webpack_public_path__ + "img/arrow.1976fc44.png";